import { initFrontendPerformanceMonitor } from '@/reporting/performance';
import { useEffect } from 'react';

export function useFrontendPerformanceMonitor(): void {
  useEffect(() => {
    initFrontendPerformanceMonitor();
  }, []);
}
